import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import gallerybanner from '../Assets/Images/Gallerybanner.jpg';

import img1 from "../Assets/Images/team1.jpg";
import img2 from "../Assets/Images/team2.jpg";
import img3 from "../Assets/Images/team10.jpg";
import img4 from "../Assets/Images/team12.jpg";
import img5 from "../Assets/Images/team16.jpg";
import img6 from "../Assets/Images/team3.jpg";
import img7 from "../Assets/Images/team5.jpg";
import img8 from "../Assets/Images/team7.jpg";
import img9 from "../Assets/Images/team15.jpg";
import img10 from "../Assets/Images/team8.jpg";
import img11 from "../Assets/Images/team23.jpg";
import img12 from "../Assets/Images/team6.jpg";
import img13 from "../Assets/Images/team18.jpg";
import img14 from "../Assets/Images/team4.jpg";
import img15 from "../Assets/Images/team9.jpg";

import { Helmet } from "react-helmet";

const images = [
  img1, img2, img3, img4, img5,
  img6, img7, img8, img9, img10,
  img11, img13, img14, img15, img12,
];

export default function Gallery() {
  return (
    <div className="mainnav">
<Helmet>
      <title>Gallery | Sumanik Security And Allied Services Pvt Ltd</title>
      <meta
        name="description"
        content="Explore moments from the team at Sumanik Security — our commitment, professionalism, and unity captured in action across India."
      />
      <meta
        name="keywords"
        content="Sumanik Security Team, Security Guard Photos, Security Company Gallery, Professional Security Team, Staff Moments, Company Culture"
      />
      <meta name="author" content="Sumanik Security And Allied Services Pvt Ltd" />
      <meta property="og:title" content="Our Team Moments | Sumanik Security Pvt Ltd" />
      <meta
        property="og:description"
        content="See how the team at Sumanik Security And Allied Services works together. View team photos, training moments, and behind-the-scenes shots."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.sumaniksecurity.com/gallery" />
      <meta property="og:image" content="https://www.sumaniksecurity.com/images/gallery-cover.jpg" />
    </Helmet>


      <div className="about-banner position-relative text-white">
          <img
            src={gallerybanner}
            alt="About Banner"
            className="aboutbanner-image "
          />
          <div className="maindesc position-absolute top-50 start-50 translate-middle px-3 text-center">
            <h2 className="fw-bold">Gallery - Sumanik Security and Allied Services Pvt Ltd</h2>
            <p className="lead">
              
            </p>
          </div>
        </div>

      <div className="py-5" style={{ background: "linear-gradient(135deg, #fdfbfb, #ebedee)" }}>
        <Container>
          <h2 className="Mainhead mb-5">Our Team Moments</h2>
          <Row>
            {images.map((img, index) => (
              <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-4">
                <div className="gallery-card shadow-sm rounded overflow-hidden">
                  <img
                    src={img}
                    alt={`team-${index + 1}`}
                    className="w-100 h-100"
                    style={{
                      height: "250px",
                      objectFit: "cover",
                      transition: "transform 0.3s ease",
                    }}
                    onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                    onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
                  />
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </div>
  );
}
